import React, { useEffect, useState } from "react"
import NoDataFound from "../utilsComponent/noDataFound";
import { REACT_APP_VAM_CONTEXT_COMPENSATION, REACT_APP_VAM_ENDPOINT } from "../urls";
import { Modal, ModalBody, ModalFooter, ModalHeader, Button } from "react-bootstrap";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { format } from "date-fns";
import { toast } from "react-toastify";
import Select from 'react-select';
import DatePicker from 'react-datepicker';
import ListsPagination from "../utilsComponent/ListsPagination";
import { axiosRequest } from "../service";
import { editModeOn } from "../utilFunctions";
import { functionalities, KISAN_SATHI } from "../consts";
import "../scss/compensationMaster.scss"

const CompensationMasters = (props) => {
    const {roleDataCookie, productNames} = props
    const cropPatternTypeOptions = [
        { label: 'Single Harvest/Picking', value: 'Single Harvest/Picking' },
        { label: 'Multiple Harvests /Pickings', value: 'Multiple Harvests /Pickings' }
    ];
    const [compensationMastersList, setCompensationMastersList] = useState([])
    const [showAddPopover, setShowAddPopover] = useState(false);
    const [editMode, setEditMode] = useState(false)
    const defaultPayload = {
        "id": null,
        "productID": null,
        "cropStart": '',
        "cropEnd": '',
        "compPercent": '',
        "startDate": null,
        "endDate": null,
        "cropPatternType": null,
        "createdBy": roleDataCookie?.userID,
    }
    const [compensationPayload, setCompensationPayload] = useState(defaultPayload)
    const [currentItems, setCurrentItems] = useState([])
    const [sortedProductId, setSortedProductId] = useState(true)
    const [sortedCompensation, setSortedCompensation] = useState(true)
    const [sortedCropStart, setSortedCropStart] = useState(true)
    const [sortedCropEnd, setSortedCropEnd] = useState(true)

    useEffect(() => {
        getCompensationMastersList()
    }, [])

    const hanldeDatechange = (date, key) => {
        if (date) {
            const year = date.getFullYear();
            const month = (date.getMonth() + 1).toString().padStart(2, '0')
            const dat1 = (date.getDate()).toString().padStart(2, '0')
            setCompensationPayload({ ...compensationPayload, [key]: `${year}-${month}-${dat1}` })
        }
    }
    const addCompensationMaster = () => {
        if(!compensationPayload.productID){
            toast.error("Please Select Product Name.")
            return
        }else if (compensationPayload.productID.value === KISAN_SATHI && !compensationPayload.cropPatternType) {
            toast.error("Please Select Crop Pattern.")
            return
        }else if(!String(compensationPayload.cropStart)){
            toast.error("Please Enter Crop Duration Start Range.")
            return
        }else if(!String(compensationPayload.cropEnd)){
            toast.error("Please Enter Crop Duration End Range.")
            return
        }else if(!String(compensationPayload.compPercent)){
            toast.error("Please Enter Compensation Percentage.")
            return
        }else if(!compensationPayload.startDate){
            toast.error("Please Enter Start Date.")
            return
        }else if(!compensationPayload.endDate){
            toast.error("Please Enter End Date.")
            return
        }else {
            const payloadToSend = {
                ...compensationPayload,
                productID: compensationPayload.productID.value,
                cropPatternType: compensationPayload.cropPatternType?.value || null,
            }
            if(editMode){
                axiosRequest().put(`${REACT_APP_VAM_ENDPOINT}/${REACT_APP_VAM_CONTEXT_COMPENSATION}/updateCompensation`, payloadToSend)
                .then(data => {
                    setEditMode(false)
                    setCompensationPayload(defaultPayload)
                    getCompensationMastersList()
                    if(data.data.includes('The requested date/crop range overlaps with the existing range')) toast.error(data.data)
                    else toast.success(data.data)
                    setShowAddPopover(false)
                }).catch(error => (
                    console.log(error)
                )
                )
            }else{
                axiosRequest().post(`${REACT_APP_VAM_ENDPOINT}/${REACT_APP_VAM_CONTEXT_COMPENSATION}/createCompensation`, payloadToSend)
                .then(data => {
                    setCompensationPayload(defaultPayload)
                    getCompensationMastersList()
                    if(data.data.includes('The requested date/crop range overlaps with the existing range')) toast.error(data.data)
                    else toast.success(data.data)
                    setShowAddPopover(false)
                }).catch(error => (
                    console.log(error)
                )
                )
            }
        }
    }
    const clickedOnEditMode = (data) => {
        const selectedProduct = productNames.find(product => product.value === data.productID);
        const selectedCropPattern = cropPatternTypeOptions.find(option => option.value === data.cropPatternType);
        setCompensationPayload({   
            "id": data.id,
            "productID": selectedProduct || null,
            "cropStart": data.cropStart,
            "cropEnd": data.cropEnd,
            "compPercent": data.compPercent,
            "startDate": data.startDate,
            "endDate": data.endDate,
            "cropPatternType": selectedCropPattern || null
        })
        setEditMode(true);
        setShowAddPopover(true)
    }

    const getCompensationMastersList = () => {
        axiosRequest().get(`${REACT_APP_VAM_ENDPOINT}/${REACT_APP_VAM_CONTEXT_COMPENSATION}/getAllCompensations`).then(data => {
            setCompensationMastersList(data.data)
        }).then(error => {
            console.log(error)
        })
    }
    const handleAdd = () => {
        setShowAddPopover(!showAddPopover);
        setCompensationPayload(defaultPayload);
        setEditMode(false);
    };
    const addCompensation = () => {
        setCompensationPayload(defaultPayload)
        setShowAddPopover(!showAddPopover) 
        setEditMode(false)
    }
    const sortingData = (data) => {
        switch (data) {
         case "sortedProductId":
             if (!sortedProductId) {
                 const lists = [...compensationMastersList]
                 lists.sort((a, b) => a.productID - b.productID)
                 setCompensationMastersList([...lists])
                 setSortedProductId(true)
             } else {
                 const lists = [...compensationMastersList]
                 lists.sort((a, b) => b.productID - a.productID)
                 setCompensationMastersList([...lists])
                 setSortedProductId(false)
             }
             break;
         case "sortedCompensation":
             if (!sortedCompensation) {
                 const lists = [...compensationMastersList]
                 lists.sort((a, b) => a.compPercent - b.compPercent)
                 setCompensationMastersList([...lists])
                 setSortedCompensation(true)
             } else {
                 const lists = [...compensationMastersList]
                 lists.sort((a, b) => b.compPercent - a.compPercent)
                 setCompensationMastersList([...lists])
                 setSortedCompensation(false)
             }
             break;
             case "sortedCropStart":
                if (!sortedCropStart) {
                    const lists = [...compensationMastersList]
                    lists.sort((a, b) => a.cropStart - b.cropStart)
                    setCompensationMastersList([...lists])
                    setSortedCropStart(true)
                } else {
                    const lists = [...compensationMastersList]
                    lists.sort((a, b) => b.cropStart - a.cropStart)
                    setCompensationMastersList([...lists])
                    setSortedCropStart(false)
                }
                break;
            case "sortedCropEnd":
                if (!sortedCropEnd) {
                    const lists = [...compensationMastersList]
                    lists.sort((a, b) => a.cropEnd - b.cropEnd)
                    setCompensationMastersList([...lists])
                    setSortedCropEnd(true)
                } else {
                    const lists = [...compensationMastersList]
                    lists.sort((a, b) => b.cropEnd - a.cropEnd)
                    setCompensationMastersList([...lists])
                    setSortedCropEnd(false)
                }
                break;
            //  case "sortedProductName":
            //      if (!sortedProductName) {
            //        const lists = [...compensationMastersList]
            //        lists.sort((a, b) => a.lastName?.toLowerCase().localeCompare(b.lastName?.toLowerCase()))
            //        setIndemnityLists([...lists])
            //        setSortedProductName(true)
            //      } else {
            //        const lists = [...indemnityLists]
            //        lists.sort((a, b) => b.lastName?.toLowerCase().localeCompare(a.lastName?.toLowerCase()))
            //        setIndemnityLists([...lists])
            //        setSortedProductName(false)
            //      }
            //      break;
       default:
     }
    
    }
    return (
        <section className="p-4">
            <h1 className="headerclaim">Compensation Master</h1>
            <hr className="upper_hr" />
            <div className="outer-box_vendorMasters">
                <div style={{ justifyContent: 'space-between', display: 'flex', flexDirection: 'row', width: '100%' }}>
                    <h2 className="heading_h2Masters">Compensation Master</h2>
                    {editModeOn(functionalities.COMPENSATION_MASTER_TAB) && (
                        <button className={'btn btn-success mt-4 mb-4 px-4'} onClick={() => addCompensation()} style={{ marginRight: '2%' }}><i className="fa fa-plus" aria-hidden="false"></i> Add</button>
                    )}
                    <Modal show={showAddPopover} isOpen={showAddPopover} toggle={handleAdd} centered={true} backdrop={'static'}>
                        <ModalHeader>
                            {editMode ? <h5>Edit Compensation</h5> : <h5>Add Compensation</h5>}
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" onClick={handleAdd} ></button>
                        </ModalHeader>
                        <ModalBody>
                            <div className="form-group mb-3">
                                <form action>
                                {
                                        !editMode && (
                                            <>
                                                <div className="form-group mb-3">
                                                <label for="exampleInputPassword1">Product Name</label>
                                                    <Select id="exampleInputPassword1" options={productNames}
                                                        onInputChange={(inputValue) => {
                                                            // Replace non-alphanumeric characters
                                                            const cleanedValue = inputValue.replace(/[^A-Za-z]/g, '');
                                                            return cleanedValue; // Return cleaned value for the Select component
                                                        }}
                                                        placeholder="Kshema Product"
                                                        value={compensationPayload?.productID?.label ? compensationPayload.productID : { label: "Product"}}
                                                        onChange={(data) => {                    
                                                            setCompensationPayload({ ...compensationPayload, 'productID': data, 'cropPatternType': null })
                                                        }}
                                                    />
                                                </div>                                
                                            </>
                                        )
                                    }
                                    {/* Conditionally render Crop Pattern select */}
                                    {compensationPayload.productID?.value === KISAN_SATHI && (
                                        <div className="form-group mb-3">
                                            <label htmlFor="cropPatternType">Crop Pattern</label>
                                            <Select
                                                id="cropPatternType"
                                                options={cropPatternTypeOptions}
                                                placeholder="Select Crop Pattern"
                                                value={compensationPayload.cropPatternType}
                                                onChange={(data) => {
                                                    setCompensationPayload({ ...compensationPayload, 'cropPatternType': data })
                                                }}
                                            />
                                        </div>
                                    )}
                                     <div className="form-group mb-3">
                                                    <label for="indemnitypercentage" className="form-label">Crop Duration Start Range</label>
                                                    <input type="text" className="form-control" id="indemnitypercentage" placeholder="Crop Duration Start Range %" onChange={(e) => {
                                                        const numericValue = e.target.value.replace(/[^0-9.,]/g, '');
                                                        e.target.value = numericValue;
                                                        if(Number(e.target.value) > 100){
                                                            return
                                                        }
                                                        setCompensationPayload({ ...compensationPayload, 'cropStart': Number(e.target.value) })
                                                    }} value={compensationPayload.cropStart}/>
                                                </div>
                                                <div className="form-group mb-3">
                                                    <label for="indemnitypercentage" className="form-label">Crop Duration End Range</label>
                                                    <input type="text" className="form-control" id="indemnitypercentage" placeholder="Crop Duration End Range %" onChange={(e) => {
                                                        const numericValue = e.target.value.replace(/[^0-9.,]/g, '');
                                                        e.target.value = numericValue;
                                                        if(Number(e.target.value) > 100){
                                                            return
                                                        }
                                                        setCompensationPayload({ ...compensationPayload, 'cropEnd': Number(e.target.value) })
                                                    }} value={compensationPayload.cropEnd}/>
                                                </div>
                                                <div className="form-group mb-3">
                                                    <label for="indemnitypercentage" className="form-label">Compensation %</label>
                                                    <input type="text" className="form-control" id="indemnitypercentage" placeholder="Compensation %" onChange={(e) => {
                                                        const numericValue = e.target.value.replace(/[^0-9.,]/g, '');
                                                        e.target.value = numericValue;
                                                        if(Number(e.target.value) > 100){
                                                            return
                                                        }
                                                        setCompensationPayload({ ...compensationPayload, 'compPercent': Number(e.target.value) })
                                                    }} value={compensationPayload.compPercent}/>
                                                </div>      
                                    <div className="form-group mb-3">
                                        <label for="validitystart" className="form-label">Validity Start</label>
                                        <div className='form-control'>
                                            <DatePicker
                                                selected={compensationPayload?.startDate && compensationPayload?.startDate}
                                                // className="align4_dataPolicy"
                                                maxDate={compensationPayload?.endDate && compensationPayload?.endDate}
                                                onChange={(date) => hanldeDatechange(date, 'startDate')}
                                                dateFormat="dd-MM-yyyy"
                                                placeholderText="dd-mm-yyyy"
                                                // maxDate={new Date()}
                                                // highlightDates={new Date()}
                                                onKeyDown={(e) => e.preventDefault()}
                                                showYearDropdown
                                                showMonthDropdown
                                                scrollableYearDropdown
                                                yearDropdownItemNumber={1000}
                                            />
                                        </div>
                                    </div>
                                    <div className="form-group mb-3">
                                        <label for="validitystart" className="form-label">Validity End</label>
                                        <div className='form-control'>
                                            <DatePicker
                                                selected={compensationPayload?.endDate && compensationPayload?.endDate}
                                                // className="align4_dataPolicy"
                                                minDate={compensationPayload?.startDate && compensationPayload?.startDate}
                                                onChange={(date) => hanldeDatechange(date, 'endDate')}
                                                dateFormat="dd-MM-yyyy"
                                                placeholderText="dd-mm-yyyy"
                                                // maxDate={new Date()}
                                                // highlightDates={new Date()}
                                                onKeyDown={(e) => e.preventDefault()}
                                                showYearDropdown
                                                showMonthDropdown
                                                scrollableYearDropdown
                                                yearDropdownItemNumber={1000}
                                            />
                                        </div>
                                    </div>
                                </form>
                            </div></ModalBody>
                        <ModalFooter style={{ justifyContent: 'center' }}>
                            <Button style={{ borderColor: 'green', backgroundColor: '#157347', color: 'white' }} onClick={() => addCompensationMaster()}>Save</Button>
                        </ModalFooter>
                    </Modal>

                </div >
                {
                    compensationMastersList && compensationMastersList.length > 0 ? (
                        <>
                            <table className="tableHeaderBg table table-strip mt-3 text-left">
                                <thead>
                                    <tr>
                                        <th rowSpan="2">S No.</th>
                                        <th rowSpan="2">Product Name<a className="pointer text-body ms-1" onClick={() => sortingData("sortedProductId")}><svg xmlns="http://www.w3.org/2000/svg" className="pointer" width="16" height="16" fill="currentColor" class="bi bi-filter" viewBox="0 0 16 16">
                                            <path d="M6 10.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5m-2-3a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5m-2-3a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 0 1h-11a.5.5 0 0 1-.5-.5" />
                                        </svg></a></th>
                                        <th className="text-center" colSpan="2">Crop Duration Age %</th>
                                        <th rowSpan="2">Compensation %<a className="pointer text-body ms-1" onClick={() => sortingData("sortedCompensation")}><svg xmlns="http://www.w3.org/2000/svg" className="pointer" width="16" height="16" fill="currentColor" class="bi bi-filter" viewBox="0 0 16 16">
                                            <path d="M6 10.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5m-2-3a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5m-2-3a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 0 1h-11a.5.5 0 0 1-.5-.5" />
                                        </svg></a></th>
                                        <th rowSpan="2">Validity Start</th>
                                        <th rowSpan="2">Validity End</th>
                                        {editModeOn(functionalities.COMPENSATION_MASTER_TAB) && (
                                            <th rowSpan="2">Action</th>
                                        )}
                                    </tr>
                                    <tr>
                                        <th>Start Range<a className="pointer text-body ms-1" onClick={() => sortingData("sortedCropStart")}><svg xmlns="http://www.w3.org/2000/svg" className="pointer" width="16" height="16" fill="currentColor" class="bi bi-filter" viewBox="0 0 16 16">
                                            <path d="M6 10.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5m-2-3a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5m-2-3a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 0 1h-11a.5.5 0 0 1-.5-.5" />
                                        </svg></a></th>
                                        <th>End Range<a className="pointer text-body ms-1" onClick={() => sortingData("sortedCropEnd")}><svg xmlns="http://www.w3.org/2000/svg" className="pointer" width="16" height="16" fill="currentColor" class="bi bi-filter" viewBox="0 0 16 16">
                                            <path d="M6 10.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5m-2-3a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5m-2-3a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 0 1h-11a.5.5 0 0 1-.5-.5" />
                                        </svg></a></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        currentItems.map((list, index) => (
                                            <tr key={index}>
                                                <td>{index + 1}</td>
                                                <td>
                                                    {productNames.find(product => product.value === list.productID)?.label || "--"}
                                                    {list.productID === 7 && list.cropPatternType && (
                                                        <br />
                                                    )}
                                                    {list.productID === 7 && list.cropPatternType && (
                                                        `(${cropPatternTypeOptions.find(option => option.value === list.cropPatternType)?.label || '--'})`
                                                    )}
                                                </td>
                                                <td>{list.cropStart}%</td>
                                                <td>{list.cropEnd}%</td>
                                                <td>{list.compPercent}%</td>
                                                <td>{format(new Date(list.startDate), 'dd-MMM-yyyy')}</td>
                                                <td>{format(new Date(list.endDate), 'dd-MMM-yyyy')}</td>
                                                {editModeOn(functionalities.COMPENSATION_MASTER_TAB) && (
                                                    <td  onClick={() => { clickedOnEditMode(list) }} className='tableButtonBg '><FontAwesomeIcon icon="fas fa-edit" className='edit_button' /></td>
                                                )}
                                            </tr>
                                        ))
                                    }
                                </tbody>
                            </table>
                            <ListsPagination setCurrentItems={setCurrentItems} lists={compensationMastersList}/>  
                        </>
                    ) : <NoDataFound text="No Data Found" />
                }
            </div >
        </section >
    )
};

export default CompensationMasters;